import {MI} from "../init";

/**
 * @constructor
 * @param {GameConfig} cfg
 * @returns {ReelPrinter}
 */
export function ReelPrinter(cfg) {
    /** @type {GameConfig} */
    this._gameCfg = cfg;
};


/**
 * @param {SpinReel} reel
 */
ReelPrinter.prototype.print = function(reel) {

    var he = MI.getHe() - 20;
    var heHalf = he / 2;

    var reelXShift = this._getShiftXByReel(reel.id);
    var symbols = reel.getSymbols();

    for(var k = 0; k < symbols.length; k++) {

        var i = reel.id;

        var pos = this._gameCfg.reelsPositions[i]["y"] + ((this._gameCfg.symbolHeight + this._gameCfg.symbolOffsetY) * k) + reel.shiftY;
        var xAdd = 0;

        if(pos < heHalf) {
            xAdd = (pos / heHalf) * reelXShift;
        } else {
            xAdd = ((he - pos) / heHalf) * reelXShift;
        }

        if(symbols[k].locked) {
            return;
        }



//		if(i === 0) {
//			console.log(pos, xAdd);
//		}

        symbols[k] && symbols[k].setPos(
            this._gameCfg.reelsPositions[i]["x"] + xAdd,
            pos,
            true
        );
    }
};

ReelPrinter.prototype._getShiftXByReel = function(i) {

    switch(i)
    {
        case 0:
            return -30;
        case 1:
            return -15;
        case 2:
            return 15;
        case 3:
            return 30;
    }
};